import { useEffect, useMemo, useState } from "react";
import { useSelector } from "react-redux";
import GnaUtilisationVolumeAnylysis from "./GnaUtilisationVolume";
import DailyAnalysis from "./DailyUtilisation/DailyAnalysis";
import MonthAnalysis from "./DailyUtilisation/MonthAnalysis";

export default function GnaTgnaOptimalUtilisationAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  selectedTargetDate,
  selectedState,
  selectedExchanges = [],
  selectedMarkets = [],
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  selectedTargetDate: any[];
  selectedState?: string;
  selectedExchanges?: string[];
  selectedMarkets?: string[];
}) {
  const DefaultDates = useSelector(
    (state: any) => state.defaultDatesSetter.defaultDates
  );

  const [availableDates, setAvailableDates] = useState<any[]>([]);

  // Sync available dates from Prop (selectedTargetDate)
  useEffect(() => {
    if (selectedTargetDate && selectedTargetDate.length > 0) {
      setAvailableDates(selectedTargetDate);
    } else {
      // Fallback to Redux if prop is empty (optional, or just empty)
      const dateKey = "Power Market";
      const trendDates = DefaultDates?.[dateKey]?.defaultTrendDates || [];
      setAvailableDates(trendDates);
    }
  }, [selectedTargetDate, DefaultDates]);

  // Memoize stable props for children to prevent blinking
  const safeSelectedExchanges = useMemo(() => selectedExchanges || [], [selectedExchanges]);
  const safeSelectedMarkets = useMemo(() => selectedMarkets || [], [selectedMarkets]);



  return (
    <>
      <div
        className=" gas-chart-container !p-0 !m-0"
        style={{
          height: "calc(-195px + 100vh)",
          width: "100%",
        }}
      >
        <div className="load-data grid grid-cols-2 p-0 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-2 h-full w-full md:overflow-hidden rounded-2xl !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]">
          <div className="col-span-1 md:col-span-12 w-full !h-[100%]">
            <div className="flex flex-col md:flex-row gap-2 !h-[100%]">
              <DailyAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                selectedTargetDate={selectedTargetDate}
                selectedState={selectedState}
                selectedExchanges={safeSelectedExchanges}
                selectedMarkets={safeSelectedMarkets}
              />
              <MonthAnalysis
                selectedBlock={selectedBlock}
                refreshKey={refreshKey}
                setError={setError}
                selectedTargetDate={selectedTargetDate}
                selectedState={selectedState}
                selectedExchanges={safeSelectedExchanges}
                selectedMarkets={safeSelectedMarkets}
              />
            </div>
          </div>
          <div className="dash-card col-span-1 md:col-span-12 border border-[#718EBF1C] !bg-[#fff] !shadow-[rgba(149,157,165,0.2)_0px_8px_24px] !p-2 !min-h-[100%] w-full">
            <div className="flex justify-between items-center mb-0 px-4 py-2 border-b border-gray-100">
              <h2 className="chartHeading !text-sm">State Metrics Analysis</h2>
              <div className="flex items-center gap-3">
                {/* Removed SearchBox as we now show multiple ranges in comparison */}
              </div>
            </div>

            <GnaUtilisationVolumeAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={false} // Parent no longer manages loading
              selectedTargetDate={selectedTargetDate}
              data={null} // Deprecated
              availableDates={availableDates}
              selectedState={selectedState}
              selectedExchanges={safeSelectedExchanges}
              selectedMarkets={safeSelectedMarkets}
            />

          </div>
        </div>
      </div>
    </>
  );
}
